module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC05_ua.f78c1bcb.webp";